// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Drawer } from '../../../drawer';
import { OptionCard } from '../option-card';
import { TenantDrawerContainer } from './style';
import { getTenantOptionParts, getTenantOptionTitleKey, } from './tenant-option-description';
import { TenantDescription } from './tenant-description';
/** Ordem em que as zonas aparecem na lista. */
const ZONES = ['SAZ', 'LAS', 'MAZ'];
export const TenantDrawerComponent = ({ isOpen, onClose, availableOptions = [], currentOption, loading, switchTenant, }) => {
    const [selectedId, setSelectedId] = useState(currentOption?.id);
    const { t } = useTranslation('drawerChangeTenant');
    useEffect(() => {
        setSelectedId(currentOption?.id);
    }, [isOpen]);
    const renderBody = () => {
        if (loading) {
            return (React.createElement("p", { className: "drawer-tenant_feedback" }, t('drawerChangeTenant:loading')));
        }
        if (!availableOptions.length) {
            return (React.createElement("p", { className: "drawer-tenant_feedback" }, t('drawerChangeTenant:empty')));
        }
        // Lista única: a zona entra na própria linha da opção, sem subtítulo.
        return [...availableOptions]
            .sort((a, b) => ZONES.indexOf(a.zone) - ZONES.indexOf(b.zone))
            .map((option) => (React.createElement(OptionCard, { key: option.id, name: "tenant", value: option.id, country: option.country, title: t(getTenantOptionTitleKey(option)), description: React.createElement(TenantDescription, { parts: getTenantOptionParts(option, { withZone: true }) }), checked: option.id === selectedId, onChange: setSelectedId })));
    };
    const canSwitch = !!selectedId && selectedId !== currentOption?.id;
    return ReactDOM.createPortal(React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, title: t('drawerChangeTenant:title'), cancelButton: {
            text: t('drawerChangeTenant:btnCancel'),
        }, confirmButton: {
            text: t('drawerChangeTenant:btnConfirm'),
            onClick: () => switchTenant(selectedId),
            disabled: !canSwitch,
        } },
        React.createElement(TenantDrawerContainer, null,
            React.createElement("p", { className: "drawer-tenant_description" }, t('drawerChangeTenant:description')),
            React.createElement("section", { className: "drawer-tenant_body" }, renderBody()))), document.getElementById('root-app_side_content'));
};
//# sourceMappingURL=component.js.map